import * as Tabs from '@radix-ui/react-tabs';
import cn from 'classnames';
import styles from './StatsPageInfo.module.scss';

export type StatColor = 'purple' | 'green' | 'orange' | 'teal' | 'red' | 'gray' | 'blue';

export interface StatCard {
  value: string;
  label: string;
  count: number | null | undefined;
  color: StatColor;
  icon: React.ReactNode;
  disabled?: boolean;
}

interface StatsPageInfoProps {
  activeStatus: string;
  onStatusChange: (value: string) => void;
  cards: StatCard[];
}

const CountValue = ({ value }: { value: number | null | undefined }) => {
  if (value !== null && value !== undefined) {
    return <>{value.toLocaleString('ru-RU')}</>;
  }
  return <span className={styles.amountPlaceholder}>0</span>;
};

const colorClassMap: Record<StatColor, string> = {
  purple: styles.tabsPurple,
  green: styles.tabsGreen,
  orange: styles.tabsOrange,
  teal: styles.tabsTeal,
  red: styles.tabsRed,
  gray: styles.tabsGray,
  blue: styles.tabsBlue,
};

export const StatsPageInfo = ({
  activeStatus,
  onStatusChange,
  cards,
}: StatsPageInfoProps) => {
  return (
    <Tabs.Root
      className={styles.tabsRoot}
      value={activeStatus}
      onValueChange={onStatusChange}
    >
      <Tabs.List className={styles.tabsList}>
        {cards.map(card => (
          <Tabs.Trigger
            key={card.value}
            value={card.value}
            disabled={card.disabled}
            className={cn(styles.tabsTrigger, colorClassMap[card.color], {
              [styles.tabsTriggerActive]: activeStatus === card.value,
              [styles.tabsDisabled]: card.disabled,
            })}
          >
            <div className={styles.tabIconWrapper}>{card.icon}</div>
            <div className={styles.tabInfo}>
              <span className={styles.tabLabel}>{card.label}</span>
              <span className={styles.tabCount}>
                <CountValue value={card.count} />
              </span>
            </div>
          </Tabs.Trigger>
        ))}
      </Tabs.List>
    </Tabs.Root>
  );
};
